import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-error-loading-details',
  imports: [],
  templateUrl: './error-loading-details.component.html',
  styleUrl: './error-loading-details.component.scss',
})
export class ErrorLoadingDetailsComponent {
  claimType = input.required<'repair' | 'service'>();

  protected viewModel = computed(() => {
    return {
      claimType: this.claimType(),
    };
  });

  get vm() {
    return this.viewModel();
  }
}
